<template>
  <div class="research_wrap">
    <el-carousel
      height="37vw"
      loop
      arrow="never"
      class="hidden-xs-only"
      indicator-position="none"
    >
      <el-carousel-item v-for="(item, index) in carouselList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1>{{ langContent.shopping.title }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="research_card hidden-xs-only">
      <div class="pricing_table">
        <table class="table_content">
          <thead>
            <tr>
              <th colspan="4">{{ langContent.pricing.systemTitle }}</th>
            </tr>
            <tr>
              <th colspan="4">{{ langContent.pricing.serviceFee }}</th>
            </tr>
            <tr class="plan_row">
              <th>{{ langContent.pricing.title }}</th>
              <th>{{ langContent.pricing.silver }}</th>
              <th>{{ langContent.pricing.gold }}</th>
              <th>{{ langContent.pricing.enterprise }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ langContent.pricing.scope }}</td>
              <td>{{ langContent.pricing.scope2 }}</td>
              <td>{{ langContent.pricing.scopeGold }}</td>
              <td>{{ langContent.pricing.scopeGold2 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.product }}</td>
              <td>{{ langContent.pricing.product2 }}</td>
              <td>{{ langContent.pricing.productGold }}</td>
              <td>{{ langContent.pricing.productGold2 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.report }}</td>
              <td>{{ langContent.pricing.report2 }}</td>
              <td>{{ langContent.pricing.report3 }}</td>
              <td>{{ langContent.pricing.report4 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.supplier }}</td>
              <td>{{ langContent.pricing.supplier2 }}</td>
              <td>{{ langContent.pricing.supplier3 }}</td>
              <td>{{ langContent.pricing.supplier4 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.analysis }}</td>
              <td>{{ langContent.pricing.analysis2 }}</td>
              <td>{{ langContent.pricing.analysis3 }}</td>
              <td>{{ langContent.pricing.analysis4 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.dashboard }}</td>
              <td>{{ langContent.pricing.dashboard2 }}</td>
              <td>{{ langContent.pricing.dashboard3 }}</td>
              <td>{{ langContent.pricing.dashboard4 }}</td>
            </tr>
            <tr class="price_row">
              <td>{{ langContent.pricing.price.free }}</td>
              <td>{{ langContent.pricing.price.silver }}</td>
              <td>{{ langContent.pricing.price.gold }}</td>
              <td>{{ langContent.pricing.price.enterprise }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="research_sp_wrap_mobile hidden-sm-and-up">
      <div class="pricing_table">
        <table class="table_content">
          <thead>
            <tr>
              <th colspan="4">{{ langContent.pricing.systemTitle }}</th>
            </tr>
            <tr>
              <th colspan="4">{{ langContent.pricing.serviceFee }}</th>
            </tr>
            <tr class="plan_row">
              <th>{{ langContent.pricing.title }}</th>
              <th>{{ langContent.pricing.silver }}</th>
              <th>{{ langContent.pricing.gold }}</th>
              <th>{{ langContent.pricing.enterprise }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ langContent.pricing.scope }}</td>
              <td>{{ langContent.pricing.scope2 }}</td>
              <td>{{ langContent.pricing.scopeGold }}</td>
              <td>{{ langContent.pricing.scopeGold2 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.product }}</td>
              <td>{{ langContent.pricing.product2 }}</td>
              <td>{{ langContent.pricing.productGold }}</td>
              <td>{{ langContent.pricing.productGold2 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.report }}</td>
              <td>{{ langContent.pricing.report2 }}</td>
              <td>{{ langContent.pricing.report3 }}</td>
              <td>{{ langContent.pricing.report4 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.supplier }}</td>
              <td>{{ langContent.pricing.supplier2 }}</td>
              <td>{{ langContent.pricing.supplier3 }}</td>
              <td>{{ langContent.pricing.supplier4 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.analysis }}</td>
              <td>{{ langContent.pricing.analysis2 }}</td>
              <td>{{ langContent.pricing.analysis3 }}</td>
              <td>{{ langContent.pricing.analysis4 }}</td>
            </tr>
            <tr>
              <td>{{ langContent.pricing.dashboard }}</td>
              <td>{{ langContent.pricing.dashboard2 }}</td>
              <td>{{ langContent.pricing.dashboard3 }}</td>
              <td>{{ langContent.pricing.dashboard4 }}</td>
            </tr>
            <tr class="price_row">
              <td>{{ langContent.pricing.price.free }}</td>
              <td>{{ langContent.pricing.price.silver }}</td>
              <td>{{ langContent.pricing.price.gold }}</td>
              <td>{{ langContent.pricing.price.enterprise }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <CallMe />
    <MobileCallme style="margin-top: 600px;" />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  computed: {
    carouselList() {
      return [
        {
          src: require('@/assets/img/bg/shopping-bg.jpg'),
        }
      ]
    },
    currentLang() {
      return this.$i18n.locale
    },
    langContent() {
      return this.i18n[this.currentLang] || this.i18n.en
    }
  },
  data() {
    return {
      i18n: {
        "en": {
          "shopping": {
            "title": "Shopping Cart"
          },
          "pricing": {
            "systemTitle": "RedC",
            "serviceFee": "Available SaaS Licenses",
            "title": "SILVER",
            "silver": "GOLD",
            "gold": "PLATINUM",
            "platinum": "ENTERPRISE",
            "enterprise": "ENTERPRISE",
            "scope": "Organizational carbon footprint Scope 1,2 and 3 (Up to 2 entities)",
            "scope2": "Organizational carbon footprint Scope 1,2 and 3 (Up to 10 entities)",
            "scopeGold": "Organizational carbon footprint Scope 1,2 and 3 (Up to 30 entities)",
            "scopeGold2": "Organizational carbon footprint Scope 1,2 and 3",
            "product": "Product carbon footprint (Up to 3 products)",
            "product2": "Product carbon footprint (Up to 10 products)",
            "productGold": "Product carbon footprint (Up to 30 products)",
            "productGold2": "Product carbon footprint",
            "productPlat": "Up to 30 products",
            "report": "Basic automatic report",
            "report2": "Basic automatic report",
            "report3": "Basic automatic report",
            "report4": "Basic automatic report",
            "supplier": "",
            "supplier2": "Automated supplier engagement and data collection (Data uploaded via excel template)",
            "supplier3": "Automated supplier engagement and data collection (Data uploaded via excel template)",
            "supplier4": "Automated supplier engagement and data collection (Data uploaded via excel template)",
            "analysis": "",
            "analysis2": "Scenario analysis",
            "analysis3": "Scenario analysis",
            "analysis4": "Scenario analysis",
            "dashboard": "",
            "dashboard2": "",
            "dashboard3": "",
            "dashboard4": "Dashboard management report",
            "price": {
              "free": "Free (7 days)",
              "silver": "1299.90/mth/user",
              "gold": "1599.90/mth/user",
              "enterprise": "18000/year/2 users"
            }
          }
        },
        "zh": {
          "shopping": {
            "title": "购物车"
          },
          "pricing": {
            "systemTitle": "碳管理系统",
            "serviceFee": "订阅服务费",
            "title": "银级",
            "silver": "金级",
            "gold": "铂金级",
            "platinum": "企业级",
            "enterprise": "企业级",
            "scope": "组织碳 范围 1、2、3（最多2家公司）",
            "scope2": "组织碳 范围 1、2、3（最多10家公司）",
            "scopeGold": "组织碳 范围 1、2、3（最多30家公司）",
            "scopeGold2": "组织碳 范围 1、2、3",
            "product": "产品碳足迹（最多3个产品）",
            "product2": "产品碳足迹（最多10个产品）",
            "productGold": "产品碳足迹（最多30个产品）",
            "productGold2": "产品碳足迹",
            "productPlat": "最多30个产品",
            "report": "基础报告自动生成",
            "report2": "基础报告自动生成",
            "report3": "基础报告自动生成",
            "report4": "基础报告自动生成",
            "supplier": "",
            "supplier2": "供应商数据自主填报及格式化报告上传",
            "supplier3": "供应商数据自主填报及格式化报告上传",
            "supplier4": "供应商数据自主填报及格式化报告上传",
            "analysis": "",
            "analysis2": "碳足迹分析报告",
            "analysis3": "碳足迹分析报告",
            "analysis4": "碳足迹分析报告",
            "dashboard": "",
            "dashboard2": "",
            "dashboard3": "",
            "dashboard4": "仪表盘/管理驾驶舱",
            "price": {
              "free": "免费（7天）",
              "silver": "1299.90元/月/用户",
              "gold": "1599.90元/月/用户",
              "enterprise": "18000元/年/2个用户"
            }
          }
        }
      }
    }
  },
  components: {
    CallMe,
    MobileCallme,
  }
}
</script>




<style lang="scss" scoped>
.research_wrap {
  position: relative;
  width: 100%;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
  .research_card {
    width: 72%;
    margin: 0 auto;
    position: relative;
    z-index: 5;
    margin-top: -200px;
    background: #ffffff;
    padding: 40px;
    display: flex;
  }
  .research_sp_wrap_mobile{
    width: 100%;
    margin: 2rem auto 10rem auto;
    padding: 1rem;
    img{
      width: 100%;
    }
    p{
      font-size: 0.5rem;
    }
  }
  .pricing_table {
    width: 100%;
    margin: 20px auto 3rem auto;
    background: #fff;
    // padding: 2rem;
    // border-radius: 12px;
    // box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    // overflow-x: auto;

    .table_content {
      width: 100%;
      border: 1px solid #ccc; // 外边框
      border-collapse: collapse;
      text-align: center;
      thead {
        tr:nth-child(1),
        tr:nth-child(2) {
          th {
            text-align: left;
            font-size: 1.25rem; // 根据需要可调，比如 18px、20px、1.5rem 等
          }
        }
      }
      th,
      td {
        border: none;
        padding: 1rem;
      }

      thead th {
        background: #2f75b5;
        color: white;
        font-weight: bold;
      }

      .plan_row {
        th:nth-child(1),
        th:nth-child(3) {
          background-color: #d0f0d0;
          color: #000;
        }

        th:nth-child(2),
        th:nth-child(4) {
          background-color: #a9d08e;
          color: #000;
        }
      }


      .price_row {
        background-color: #fff !important; // 改为白色背景
        font-weight: bold;
        border-top: 1px solid #ccc; // 上边框
      }
      tbody tr {
        td:nth-child(1),
        td:nth-child(3) {
          background-color: #ffffff;
        }

        td:nth-child(2),
        td:nth-child(4) {
          background-color: #f2f2f2;
        }
      }
    }
    @media screen and (max-width: 768px) {
      font-size: 0.6rem;
    }
  }
}
</style>
